import { defineComponent as _defineComponent } from 'vue'
import { Beneficiary } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import BankAccountEditor from './BankAccountEditor.vue';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankAccountEditModal',
  props: {
    beneficiary: null
  },
  emits: ["update:beneficiary"],
  setup(__props: any, { emit }: { emit: ({
  /**
   * - update:beneficiary : payload with beneficiary
   */
  (e: 'update:beneficiary', value: Beneficiary | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  beneficiary?: Beneficiary;
};

const bankAccountEditModal = ref<InstanceType<typeof BModal> | null>(null);





const buttonTitle = computed(() => {
  return props.beneficiary ? 'Edit Bank Account' : 'Add Bank Account';
});

const title = computed(() => {
  return props.beneficiary ? 'Edit Bank Account' : 'Add Bank Account';
});

function showModal() {
  bankAccountEditModal.value!.show();
}

function hideModal() {
  bankAccountEditModal.value!.hide();
}

function onBankAccountSaved(beneficiary: Beneficiary) {
  emit('update:beneficiary', beneficiary);
  bankAccountEditModal.value!.hide();
}

return { __sfc: true,bankAccountEditModal, emit, props, buttonTitle, title, showModal, hideModal, onBankAccountSaved, BModal, BankAccountEditor }
}

})